import React from "react";
import "./Home_Banner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function Home_Banner() {
  return (
    <>
      <section className="Home_Banner">
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={0}
          slidesPerView={1}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          loop={true}
          className="banner_swiper common_swiper"
        >
          {/* Slide 1 */}
          <SwiperSlide>
            <div className="img_holder">
              <img src="/assets/images/home/home_banner/img_1.png" alt="banner img" className="banner_img"/>
            </div>
          </SwiperSlide>

          {/* Slide 2 */}
          <SwiperSlide>
            <div className="img_holder">
              <img src="/assets/images/home/home_banner/img_1.png" alt="banner img" className="banner_img"/>
            </div>
          </SwiperSlide>

          {/* Slide 3 */}
          <SwiperSlide>
             <div className="img_holder">
              <img src="/assets/images/home/home_banner/img_1.png" alt="banner img" className="banner_img"/>
            </div>
          </SwiperSlide>
        </Swiper>
      </section>
    </>
  );
}

export default Home_Banner;